const searchFacetDateJsClass = 'js-search-facet-date';
const buttonJsClass = searchFacetDateJsClass + '-button';
const inputStartJsClass = searchFacetDateJsClass + '-input-start';
const inputEndJsClass = searchFacetDateJsClass + '-input-end';
const errorStartJsClass = searchFacetDateJsClass + '-error-start';
const errorEndJsClass = searchFacetDateJsClass + '-error-end';

const searchFacetDateElements = document.querySelectorAll('.' + searchFacetDateJsClass) as NodeListOf<HTMLElement>;

const dateRegExp = new RegExp(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d{2}$/);

if (searchFacetDateElements.length > 0) {
    searchFacetDateElements.forEach((searchFacetDateElement) => {
        // We get the button element
        const buttonElement = searchFacetDateElement.querySelector('.' + buttonJsClass) as HTMLSelectElement;

        // We get the input elements
        const inputStartElement = searchFacetDateElement.querySelector('.' + inputStartJsClass) as HTMLSelectElement;
        const inputEndElement = searchFacetDateElement.querySelector('.' + inputEndJsClass) as HTMLSelectElement;

        // We get the input aria descriptions
        const inputStartAriaDescribedby = inputStartElement.getAttribute('aria-describedby');
        const inputEndAriaDescribedby = inputEndElement.getAttribute('aria-describedby');

        // We get the error elements
        const errorStartElement = searchFacetDateElement.querySelector('.' + errorStartJsClass) as HTMLSelectElement;
        const errorEndElement = searchFacetDateElement.querySelector('.' + errorEndJsClass) as HTMLSelectElement;

        if (buttonElement && inputStartElement && inputEndElement && errorStartElement && errorEndElement) {
            // We add a click event listener
            buttonElement.addEventListener('click', () => {
                // We reset the errors
                errorStartElement.style.display = 'none';
                errorEndElement.style.display = 'none';
                errorStartElement.removeAttribute('aria-describedby');
                errorEndElement.removeAttribute('aria-describedby');

                // We get the urls from the data attributes
                const facetUrl = searchFacetDateElement.dataset.facetUrl;
                const resetUrl = searchFacetDateElement.dataset.resetUrl;

                // We get the start and end date and format them
                const startDate = inputStartElement.value;
                const endDate = inputEndElement.value;

                // We reset or add the filter depending on the dates
                if (!startDate && !endDate) {
                    // We reset the filter
                    window.location.href = resetUrl;
                } else if (startDate && !endDate) {
                    // Start date only
                    // If the format is correct
                    if (dateRegExp.test(startDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', formatDate(startDate)).replace('___TO___', '');
                        window.location.href = urlWithDates;
                    } else {
                        // We show the error
                        errorStartElement.style.display = 'initial';

                        // We link the input to the error
                        inputStartElement.setAttribute('aria-describedby', `${inputStartAriaDescribedby} ${errorStartElement.id}`);

                        // We focus the input
                        inputStartElement.focus();
                    }
                } else if (!startDate && endDate) {
                    // End date only
                    // If the format is correct
                    if (dateRegExp.test(endDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', '').replace('___TO___', formatDate(endDate));
                        window.location.href = urlWithDates;
                    } else {
                        // We show the error
                        errorEndElement.style.display = 'initial';

                        // We link the input to the error
                        inputEndElement.setAttribute('aria-describedby', `${inputEndAriaDescribedby} ${errorEndElement.id}`);

                        // We focus the input
                        inputEndElement.focus();
                    }
                } else if (startDate && endDate) {
                    // Start and end dates
                    // If the format is correct
                    if (dateRegExp.test(startDate) && dateRegExp.test(endDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', formatDate(startDate)).replace('___TO___', formatDate(endDate));
                        window.location.href = urlWithDates;
                    } else {
                        if (!dateRegExp.test(endDate)) {
                            // We show the error
                            errorEndElement.style.display = 'initial';

                            // We link the input to the error
                            inputEndElement.setAttribute('aria-describedby', `${inputEndAriaDescribedby} ${errorEndElement.id}`);

                            // We focus the input
                            inputEndElement.focus();
                        }

                        if (!dateRegExp.test(startDate)) {
                            // We show the error
                            errorStartElement.style.display = 'initial';

                            // We link the input to the error
                            inputStartElement.setAttribute('aria-describedby', `${inputStartAriaDescribedby} ${errorStartElement.id}`);

                            // We focus the input
                            inputStartElement.focus();
                        }
                    }
                }
            });
        }
    });
}

/** Format dates for Solr facet. */
function formatDate (date: string): string {
    if (date) {
        // We remove slashes, reverse the order and add the time
        return date.split('/').reverse().join('') + '0000';
    } else {
        return;
    }
}